import React from "react";
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useConfig } from "../../context/ConfigContext";
function prepareName(name){
    return name.replace(/\"/g, '\'')
}

function buildAbsoluteUrl(path, config) {
    if(!path){
        return '/'
    }
    const base_url = config?.base_url || 'https://www.emmezeta.hr';

    if (!path.startsWith('/')) {
        path = '/'+path;
    }
    if (base_url) {
        return `${base_url}${path}`;
    }
    return path;
}

export default function StructuralDataBreadcrumbs({ breadcrumbs, isCategory, routeData, name }) {
    const location = useLocation();
    const { config } = useConfig();
    
    // Tworzymy dane strukturalne
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": []
    };
    
    // Dodajemy elementy do listy
    if (breadcrumbs && Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
        breadcrumbs.forEach((item) => {
            if (item && typeof item === 'object' && item.category_name && item.category_level) {
                const {category_name, category_level, category_url} = item;
                jsonLd.itemListElement.push({
                    "@type": "ListItem",
                    "position": category_level - 1,
                    "item": {
                        "@id": category_url || '',
                        "name": prepareName(category_name)
                    }
                });
            }
        });
    }
    
    // Dodajemy element dla routeData jeśli to nie kategoria
    if (!isCategory && routeData && routeData.canonical_url) {
        jsonLd.itemListElement.push({
            "@type": "ListItem",
            "position": (breadcrumbs?.length || 0) + 1,
            "item": {
                "@id": buildAbsoluteUrl(routeData.canonical_url, config),
                "name": prepareName(routeData.name || '')
            }
        });
    }
    
    // Dodajemy aktualną pozycję
    if (routeData || name) {
        jsonLd.itemListElement.push({
            "@type": "ListItem",
            "position": isCategory ? (breadcrumbs?.length || 0) + 1 : (breadcrumbs?.length || 0) + 2,
            "item": {
                "@id": buildAbsoluteUrl(location.pathname, config),
                "name": isCategory ? 
                    prepareName(routeData?.name || '') : 
                    prepareName(name || '')
            }
        });
    }
    
    // Renderujemy JSON-LD tylko jeśli mamy jakieś elementy
    if (jsonLd.itemListElement.length === 0) {
        return null;
    }

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(jsonLd)}
            </script>
        </Helmet>
    );
}